<template>
  <div>
    <v-row align="center" no-gutters>
      <v-col cols="12">
        <div class="text-center">
          <v-btn class="mx-2" @click="$emit('exit')" depressed>取消</v-btn>
          <v-btn class="mx-2" color="blue" dark @click="$emit('save')" depressed>儲存</v-btn>
        </div>
      </v-col>
      <v-col cols="12">
        <span class="mr-4">健檢日期:</span>
        <span v-text="checkDate"></span>
      </v-col>
      <v-col cols="12">
        <span class="mr-4">主治醫師:</span>
        <span v-text="report.doctor"></span>
      </v-col>
      <!-- <v-col cols="11"> -->
      <!-- <base-date-picker appendIcon="mdi-calendar-month" ref="datePicker"></base-date-picker> -->
      <!-- </v-col> -->
    </v-row>
  </div>
</template>
<script>
// import BaseDatePicker from "../../common/BaseDatePicker";

export default {
  props: ["report"],
  components: {
    // BaseDatePicker
  },
  computed: {
    checkDate() {
      if (this.report && this.report.date) {
        return this.report.date.replace(/-/g, "/");
      } else {
        return "";
      }
    }
  }
};
</script>
